import React, { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const TechCostList = ({ rsltCosts }) => {
    const [totalPrice, setTotalPrice] = useState(0);
    useEffect(() => {
        if (rsltCosts !== null && rsltCosts.length > 0) {
            let totPrice = 0;
            rsltCosts.forEach(cost => {
                totPrice += parseInt(cost.costVal);
                setTotalPrice(totPrice)
            })
        }
    }, [rsltCosts])

    return (
        <Box>
            {rsltCosts === undefined || rsltCosts === null || rsltCosts.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography variant="subtitle2" component="div">소요비용이 없습니다.</Typography>
                </Box>

            ) : (
                <TableContainer component={Box}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>No</TableCell>
                                <TableCell>종류</TableCell>
                                <TableCell>비용</TableCell>
                                <TableCell>비고</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rsltCosts.map((cost, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{cost?.costTyp}</TableCell>
                                    <TableCell>₩ {cost?.costVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                    <TableCell>{cost?.costDesc}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
            <Box sx={{display:'flex', justifyContent:'flex-end', alignItems:'center', my:1}}>
                <Typography variant="subtitle2" component="div" >총 가격:₩ {totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography>
            </Box>
        </Box>
    )
}

export default TechCostList